/* Standalone page · the full 15-step journey for one (retailer, benefit, month).
 *
 * Route: /xiaomi/partners/:retailerId/journey/:benefitId/:monthYm
 *
 * Shareable URL — drop into a Zoho ticket, a WhatsApp to a leader, etc.
 * Anyone with Xiaomi access can open, mark, undo, and add notes.
 */
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import JourneyTimeline from '@/components/XiaomiJourneyTimeline';
import BenefitOutcomePanel from '@/components/BenefitOutcomePanel';

export default function XiaomiPartnerJourneyPage() {
  const { retailerId, benefitId, monthYm } = useParams();
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-4"
      data-testid="xiaomi-journey-page">
      <button onClick={() => navigate(-1)}
        className="flex items-center gap-1.5 text-[12px] text-soft hover:text-ink"
        data-testid="journey-back">
        <ArrowLeft size={12} /> Back
      </button>

      <div className="bg-white rounded-lg border p-5"
        style={{ borderColor: '#E5E1DC' }}>
        <div className="flex items-center justify-between flex-wrap gap-2 mb-1">
          <div>
            <div className="text-[10px] uppercase tracking-wider"
              style={{ color: '#9A4B0E', fontWeight: 700 }}>
              Partner Journey · 15 steps
            </div>
            <h1 className="text-xl font-bold mt-0.5" style={{ fontFamily: 'Fraunces, serif' }}>
              Retailer #{retailerId}
            </h1>
            <div className="text-[11px] mt-0.5" style={{ color: '#6B7280' }}>
              Benefit <code>{benefitId}</code> · Month {monthYm}
            </div>
          </div>
          <Link to={`/xiaomi/partners/${retailerId}`}
            className="text-[11px] px-2 py-1 rounded border bg-white hover:bg-[#fef3c7] inline-flex items-center gap-1"
            style={{ borderColor: '#E5E1DC', color: '#1B2A4A' }}
            data-testid="journey-open-360">
            <ExternalLink size={11} /> Open 360°
          </Link>
        </div>
      </div>

      <div className="bg-white rounded-lg border p-5"
        style={{ borderColor: '#E5E1DC' }}>
        <h2 className="text-sm font-bold uppercase tracking-wider mb-3" style={{ color: '#9A4B0E' }}>
          Outcome &amp; feedback
        </h2>
        <BenefitOutcomePanel
          retailerId={retailerId}
          benefitId={benefitId}
          monthYm={monthYm}
        />
      </div>

      <div className="bg-white rounded-lg border p-5"
        style={{ borderColor: '#E5E1DC' }}>
        <JourneyTimeline
          retailerId={retailerId}
          benefitId={benefitId}
          monthYm={monthYm}
        />
      </div>
    </div>
  );
}
